const BrandColumns = () => {
  return [
    {
      title: 'Brand 1',
      dataIndex: 'brand',
      editable: true,
      width: '10%',
    },
    {
      title: 'Brand 2',
      dataIndex: 'comp1',
      editable: true,
      width: '10%',
    },
    {
      title: 'Brand 3',
      dataIndex: 'comp2',
      editable: true,
      width: '10%',
    },
    {
      title: 'Brand 4',
      dataIndex: 'comp3',
      editable: true,
      width: '10%',
    },
    {
      title: 'Brand 5',
      dataIndex: 'comp4',
      editable: true,
      width: '10%',
    },
    {
      title: 'Brand 6',
      dataIndex: 'comp5',
      editable: true,
      width: '10%',
    },
    {
      title: 'Brand 7',
      dataIndex: 'comp6',
      editable: true,
      width: '10%',
    },
    {
      title: 'Brand 8',
      dataIndex: 'comp7',
      editable: true,
      width: '10%',
    },
    {
      title: 'Brand 9',
      dataIndex: 'comp8',
      editable: true,
      width: '10%',
    },
    {
      title: 'Brand 10',
      dataIndex: 'comp9',
      editable: true,
      width: '10%',
    },
  ];
};

export default BrandColumns;
